import {Deserializable} from "./deserializable.model";

export class Categoria_Respuesta implements Deserializable {
    DatosResult?: DatosResult_Categoria;
    Mensajes: Mensaje[];

    deserialize(input: any): this {
      Object.assign(this, input);
      return this;
    }
}

export class Categoria implements Deserializable {
  Id: string;
  Nombre: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}

export class DatosResult_Categoria implements Deserializable {
  DatosListas: Categoria[];
  ListadoTiposNiveles: any;
  lista: any;

    deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}

export class Mensaje implements Deserializable {
  CodigoMensaje: string;
  DescripcionMensaje: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}

